<template lang="pug">
  v-card.list-card
    v-img(v-if="content.media" :src="content.media" :aspect-ratio="3/1")
    v-card-title.grey.lighten-4.title {{content.title}}
    v-card-text
      div(v-html="content.content")
      .mt-3.d-flexx(v-if="content.zeiten && content.zeiten.length")
        .mr-2.title Wann?
        ul
          template(v-for="zeit in content.zeiten")
            li {{showTime(zeit)}}
      .mt-3.d-flexx(v-if="content.ort")
        .mr-2.title Wo?
        div {{content.ort}}
      ul.mt-3(v-if="content.downloads && content.downloads.length")
        template(v-for="download in content.downloads")
          li: a(:href="download.url") {{download.title}}
      v-btn.mt-3(v-if="content.quelle" :href="content.quelle")
        | Quelle
        v-icon(right) launch

</template>

<script>
import moment from 'moment'

export default {
  props: ['extra'],
  computed: {
    content() {
      if (this.extra && this.extra.content) {
        return JSON.parse(this.extra.content)[0] || {}
      } else {
        return {}
      }
    }
  },
  methods: {
    showTime(time) {
      try {
        return moment(time).format("D MMM H:mm [Uhr]")
      } catch (e) {}
    }
  }
}
</script>
